import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Paper,
} from '@material-ui/core';

import ParsePaymentCardForm from '../components/forms/ParsePaymentCardForm';
import { getCompanyByReference } from '../store/companySlice';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: [theme.spacing(2)],
    },
    maxWidth: 900,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  content: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export default function Scan() {
  const classes = useStyles();
  const { reference } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (reference) {
      dispatch(getCompanyByReference({ reference }));
    }
  }, [dispatch, reference]);

  return (
    <Paper className={classes.root} elevation={1}>
      <Grid container className={classes.content}>
        <Grid item xs={12}>
          <ParsePaymentCardForm reference={reference} />
        </Grid>
      </Grid>
    </Paper>
  );
}
